module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国中央革命军事委员会旧址.44d7ef70.png";